module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Keith Rommel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Keith Rommel is a multi-award-winning author and screenwriter best known for his Thanatology dark suspense series, The Devil Tree series based on a notoriously haunted location in Florida, and the fast-paced Cultures Collide crime series. Rommel’s stories have been called “intelligent fiction” and “horror for the curious mind.” Keith has had the honor of co-writing "), _c('I', [_vm._v("The Cursed Man")]), _vm._v(" and"), _c('I', [_vm._v(" The Lurking Man")]), _vm._v(" movies which have garnished more than 160 awards combined, including best screenplays and best feature films. All of his novels are available at all major booksellers and both films are available on most major platforms. www.keithrommel.com")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9u8Iv1/tc-custom/9781620069226.jpg?1703822506181",
      "alt": "This image is the cover for the book Lurking Man, Shade of the Reaper"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lurking Man, Shade of the Reaper\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("NOW A MOTION PICTURE")])]), _c('p', [_vm._v("Cailean stands beneath a spotlight in a blinding snowstorm. She has no idea where she is or how she got there, but she senses something moving around her in the darkness outside the light."), _c('br', {
    attrs: {
      "data-mce-fragment": "1"
    }
  }), _c('br', {
    attrs: {
      "data-mce-fragment": "1"
    }
  }), _vm._v(" When the ominous presence calling himself Sariel makes himself known, he declares that he is Death Incarnate. Cailean has died, and now she will be forced to face the sins of her past in exchange for twenty-four hours of life to try to right her wrongs. And what she must do in return for this precious time is unthinkable.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Sunbury Press, Inc.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0